// A canonical countdown owns its clock. Ticker copies are plain spans, not timers.
if (!customElements.get('announcement-countdown')) {
  customElements.define('announcement-countdown', class extends HTMLElement {
    connectedCallback() {
      this.expired = false;
      this.deadline = undefined;
      const parts = (this.dataset.endDate || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (parts) {
        const [, year, month, day] = parts.map(Number);
        // Preserve the existing deadline: midnight on the selected date in the visitor's time zone.
        const date = new Date(year, month - 1, day);
        if (date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day) this.deadline = date.getTime();
      }
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.tick();
      if (!this.expired) this.timer = setInterval(() => this.tick(), 1000);
    }

    setPaused(paused) {
      this.paused = paused;
      this.tick();
    }

    tick() {
      const remaining = Math.ceil((this.deadline - Date.now()) / 1000);
      if (!Number.isFinite(remaining) || remaining <= 0) {
        if (this.expired) return;
        this.expired = true;
        clearInterval(this.timer);
        const item = this.closest('[data-announcement-item]');
        if (item) { item.dataset.announcementExpired = 'true'; item.hidden = true; }
        this.dispatchEvent(new CustomEvent('announcement:countdown', { bubbles: true, detail: { expired: true } }));
        return;
      }
      const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 };
      this.querySelectorAll('[data-countdown-value]').forEach(element => { element.textContent = values[element.dataset.countdownValue]; });
      this.querySelector('[data-countdown-unit="days"]').hidden = values.days < 1;
      this.querySelector('[data-countdown-unit="seconds"]').hidden = values.days >= 1;
      this.querySelector('[data-countdown-clock]').hidden = this.paused;
      // Screen readers get the deadline once, never a changing stream of seconds.
      this.querySelector('[data-countdown-deadline]').classList.toggle('visually-hidden', !this.paused);
      this.dispatchEvent(new CustomEvent('announcement:countdown', { bubbles: true, detail: { expired: false } }));
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }
  });
}
